export const tokenCopomex = '90641157-e1c1-43a6-bc04-7b0f4dd07fc4'

/* Datos para lo que es el server en unutu de prueba 
export const host = 'http://52.22.169.24:7779/api/v1/'
export const hostSocket = 'http://52.22.169.24:7779'
Datos para produccion
export const host = 'http://52.22.169.24:7777/api/v1/'
export const hostSocket = 'http://52.22.169.24:7777'
Datos locales
export const host = 'http://localhost:7777/api/v1/'
export const hostSocket = 'http://localhost:7777'
 */
// export const host = 'http://52.22.169.24:7777/api/v1/'
// export const hostSocket = 'http://52.22.169.24:7777'
// export const hostMetricas = 'http://52.22.169.24:7781/api/v1/'


export const host = 'http://52.22.169.24:7777/api/v1/'
export const hostSocket = 'http://52.22.169.24:7777'
export const hostMetricas = 'http://52.22.169.24:7781/api/v1/'